<script setup lang="ts">
import BadgeVue from "@/common/components/BadgeVue.vue";
import { useSidebarBackground } from "@/common/composables/useSidebarBackground";
import type { NavigationLink } from "@/common/types";

import BaseIcon from "../icons/BaseIcon.vue";

defineProps<{
  navigationLink: NavigationLink;
}>();

const { sidebarHoverActiveClass, sidebarActiveClass } = useSidebarBackground();
</script>

<template>
  <a
    v-if="navigationLink.isExternalLink"
    class="group flex items-center justify-between rounded-md p-2 text-sm text-white hover:text-white"
    :class="sidebarHoverActiveClass"
    :href="navigationLink.link"
  >
    <div class="flex items-center gap-x-4">
      <BaseIcon
        :name="navigationLink.icon"
        class="text-white shrink-0 ml-2 size-6"
        aria-hidden="true"
      />
      {{ navigationLink.name }}
      <BaseIcon
        name="heroicons:arrow-top-right-on-square"
        class="text-white shrink-0 size-4"
      />
    </div>
    <BaseIcon
      v-if="navigationLink.permissionsNeeded.includes('Developer.Access')"
      name="heroicons:code-bracket"
      class="text-white shrink-0 mr-4 size-4"
    />
    <BadgeVue
      v-if="navigationLink.isBeta"
      class="bg-gray-300 text-gray-800"
    >
      beta
    </BadgeVue>
  </a>
  <RouterLink
    v-else
    :to="navigationLink.link"
    class="group flex items-center justify-between p-2 text-sm text-white"
    :class="sidebarHoverActiveClass"
    :active-class="`${sidebarActiveClass} text-white border-r-4 border-white`"
  >
    <div class="flex items-center gap-x-4">
      <BaseIcon
        :name="navigationLink.icon"
        class="shrink-0 size-6 ml-2 text-white"
        aria-hidden="true"
      />
      {{ navigationLink.name }}
    </div>
    <BaseIcon
      v-if="navigationLink.permissionsNeeded.includes('Developer.Access')"
      name="heroicons:code-bracket"
      class="text-white shrink-0 mr-2 size-4"
    />
    <BadgeVue
      v-if="navigationLink.isBeta"
      class="bg-white text-gray-800"
    >
      beta
    </BadgeVue>
  </RouterLink>
</template>
